import { links as generalLinks } from "general/links";

export default function goToError() {
  window.location.href = generalLinks.error;
}
